import {
  getCompanies,
  getYearPeriod,
  insertSchemeData,
  querySchemeData,
  updateSchemeData,
  deleteSchemeData,
} from "@/service";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  data() {
    return {
      options: {
        companies: [],
        insuranceTypes: [],
        rate: [],
        productType: [
          {
            name: "傳統型",
            value: "1",
          },
          {
            name: "投資型",
            value: "2",
          },
          {
            name: "利率變動型",
            value: "3",
          },
          {
            name: "傳統型(取大)",
            value: "4",
          },
          {
            name: "團險",
            value: "5",
          },
        ],
        contractType: [
          {
            name: "主約",
            value: "1",
          },
          {
            name: "附約",
            value: "2",
          },
        ],
        currency: [
          {
            name: "新台幣(TWD)",
            value: "1",
          },
          {
            name: "美元(USD)",
            value: "2",
          },
          {
            name: "澳幣(AUD)",
            value: "3",
          },
          {
            name: "英鎊(GBP)",
            value: "4",
          },
          {
            name: "歐元(EUR)",
            value: "5",
          },
          {
            name: "紐幣(NZD)",
            value: "6",
          },
          {
            name: "港幣(HKD)",
            value: "7",
          },
          {
            name: "日幣(JPY)",
            value: "8",
          },
          {
            name: "人民幣(CNY)",
            value: "9",
          },
          {
            name: "南非幣(ZAR)",
            value: "10",
          },
        ],
      },
      formData: {
        pln: "", //商品流水號(由後端生成)
        company: {}, //公司
        productId: "", //險種ID
        insuranceName: "", //險種名稱
        insuranceCode: "", //險種代碼
        productType: "1", //商品種類
        contractType: "1", //險種種類
        yearType: "1", //保障年期類型
        unit: "1", //單位
        schemeName: "", //計畫別名稱
        schemeQuotaType: "0", //顯示日額
        schemeQuotaDollor: "", //日額金額
        sellStatus: "1", //銷售狀態
        rate: "0", //預定利率
        currency: "1", //幣別
        endYear: "110", //保障終期
        selfRenewal: "110", //續保設定-本人續保歲數
        spouseRenewal: "110", //續保設定-配偶續保歲數
        childRenewal: "110", //續保設定-子女續保歲數
        unitPrice: "", //[單位-單位]項目後方的保額欄位，若選擇[單位-單位]才需寫入
        excludeTeenager: false, //排除15歲以下年齡的保障
        regularType: [], //繳費年期-定期型
        maturityType: [], //繳費年期-歲滿型
      },
      paymentWay: [
        {
          name: "月繳",
          value: "1",
          check: true,
        },
        {
          name: "季繳",
          value: "2",
          check: true,
        },
        {
          name: "半年繳",
          value: "3",
          check: true,
        },
        {
          name: "年繳",
          value: "4",
          check: true,
        },
        {
          name: "躉繳",
          value: "5",
          check: true,
        },
        {
          name: "彈性繳",
          value: "6",
          check: true,
        },
      ],
      schemeData: [],
      schemeEditQuotaDollor: "",
      isSchemeEdit: false,
      isSchemeQuotaDollorEmpty: false,
      isSchemeEditQuotaDollorEmpty: false,
      isSchemeNameEmpty: false,
      isUnitPriceEmpty: false,
      isPayPriodEmpty: false,
      isSchemeTableLoading: false,
    };
  },
  watch: {
    "formData.unit": function(val) {
      if ("0" == val) {
        this.querySchemeData();
      } else {
        this.initSchemeForm();
      }
      if ("3" != val) {
        this.formData.unitPrice = "";
      }
    },
    "formData.productType": function(val) {
      //[商品種類]如果選擇"利率變動型"，畫面需調整：1.隱藏[預定利率]、[續保設定]、[繳別]  2.[單位]只剩"元"跟"萬"
      if ("3" == val) {
        this.formData.unit = "1";
        //回復預設設定
        this.formData.rate = "0";
        this.formData.selfRenewal = "110";
        this.formData.spouseRenewal = "110";
        this.formData.childRenewal = "110";
      }
    },
  },
  computed: {
    isInvestType() {
      return this.formData.productType == "2";
    },
  },
  methods: {
    async getCompaniesOption() {
      const res = await getCompanies(this.$store.state.userInfo.id);
      this.options.companies = res.body;
      this.formData.company = res.body[0];
    },
    async getYearPeriodOption() {
      const res = await getYearPeriod(this.$store.state.userInfo.id);
      this.formData.regularType = res.data
        .map(({ prd: year, prdtp: type }) => ({ year, type }))
        .filter((x) => x.type == "1") //定期型 prdtp:1
        .map((v) => ({ ...v, check: false }))
        .sort((a, b) => parseInt(a.year) - parseInt(b.year));
      this.formData.maturityType = res.data
        .map(({ prd: year, prdtp: type }) => ({ year, type }))
        .filter((x) => x.type == "2") //歲滿型 prdtp:2
        .map((v) => ({ ...v, check: false }))
        .sort(
          (a, b) => parseInt(a.year.split("@")) - parseInt(b.year.split("@"))
        );
    },
    getPaymentwayList() {
      return this.paymentWay
        .filter((item) => item.check)
        .map((x) => x.value)
        .join();
    },
    getAgeperiods() {
      return this.formData.maturityType
        .filter((item) => item.check)
        .map((x) => parseInt(x.year.split("@")))
        .join();
    },
    getTerminablePeriods() {
      return this.formData.regularType
        .filter((item) => item.check)
        .map((x) => parseInt(x.year))
        .join();
    },
    getReqData(action) {
      let reqData = {
        ageperiods: this.getAgeperiods(), //繳費年期-歲滿型
        terminableperiods: this.getTerminablePeriods(), //繳費年期-定期型
        name: this.formData.insuranceName, //險種名稱
        plan_code: this.formData.insuranceCode, //險種代碼
        contracttype: this.formData.contractType, //險種種類
        currencytype: this.formData.currency, //幣別
        unit: this.formData.unit, //單位
        hage: this.formData.selfRenewal, //保設定-本人續保歲數
        phage: this.formData.spouseRenewal, //續保設定-配偶續保歲數
        chage: this.formData.childRenewal, //續保設定-子女續保歲數
        asirt: this.formData.rate, //預定利率
        status: this.formData.sellStatus, //銷售狀態
        exclude_15: this.formData.excludeTeenager ? "1" : "0", //排除15歲以下年齡的保障 是:1,否:0
        companyid: this.formData.company.COMPANYID, //公司別
        compnm: this.formData.company.COMPSNM, //公司別
        producttype: this.formData.productType, //商品種類
        unitprice: this.formData.unitPrice, //[單位-單位]項目後方的保額欄位，若選擇[單位-單位]才需寫入
        coverageyearperiodtype: this.formData.yearType, //保障年期類型
        coverageend: this.formData.endYear, //保障終期
        paymentwaylist: this.getPaymentwayList(), //繳別
        userId: this.$store.state.userInfo.id, //登入者的ID
      };

      if (!action && action !== 0) {
        //新增暫存檔
        reqData.productid =
          this.formData.unit == "0" ? this.formData.productId : ""; //若已於[單位-計畫]新增計畫別，需取得計畫別的schemeid，否則留空
      } else if (action === 0) {
        //更新暫存檔
        reqData.productid = this.formData.productId;
        reqData.pln = this.formData.pln;
        reqData.action = 0;
      } else if (action === 1) {
        //執行存檔
        reqData.productid = this.formData.productId;
        reqData.pln = this.formData.pln;
        reqData.action = 1;
      }
      return reqData;
    },
    async validateAll() {
      let isError = false;
      await this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          isError = true;
        }
        //檢核保額、檢核繳費年期、檢核計畫
        if (
          this.validateUnitPrice() ||
          this.validatePayPriod() ||
          this.validateSchemeData()
        ) {
          isError = true;
        }
      });
      if (!isError) {
        this.$validator.reset();
      }
      return isError;
    },
    validateUnitPrice() {
      let isError = false;
      this.isUnitPriceEmpty = false;
      if (this.formData.unit == "3" && !this.formData.unitPrice) {
        this.isUnitPriceEmpty = true;
        this.$toast.info({ title: "保額 不得留空" });
        isError = true;
      }
      return isError;
    },
    validateSchemeData() {
      let isError = false;
      this.isSchemeNameEmpty = false;
      this.isSchemeQuotaDollorEmpty = false;
      if (this.formData.unit == "0" && this.schemeData.length === 0) {
        this.isSchemeNameEmpty = true;
        this.isSchemeQuotaDollorEmpty = true;
        this.$toast.info({ title: "商品需設定至少一組計畫" });
        isError = true;
      }
      return isError;
    },
    validatePayPriod() {
      let isError = false;
      this.isPayPriodEmpty = false;
      if (
        this.formData.regularType.filter((item) => item.check).length +
          this.formData.maturityType.filter((item) => item.check).length ===
        0
      ) {
        this.isPayPriodEmpty = true;
        this.$toast.info({ title: "商品需設定至少一組繳費年期" });
        isError = true;
      }
      return isError;
    },
    validateSchemeForm() {
      let isError = false;
      this.isSchemeNameEmpty = false;
      this.isSchemeQuotaDollorEmpty = false;

      if (!this.formData.schemeQuotaDollor) {
        this.isSchemeQuotaDollorEmpty = true;
        isError = true;
        this.$toast.info({ title: "[日額金額]欄位不得為空" });
      }
      if (!this.formData.schemeName) {
        this.isSchemeNameEmpty = true;
        isError = true;
        this.$toast.info({ title: "[計畫別名稱]欄位不得為空" });
      }
      return isError;
    },
    validateSchemeEditForm() {
      let isError = false;
      this.isSchemeEditQuotaDollorEmpty = false;

      if (!this.schemeEditQuotaDollor) {
        this.isSchemeEditQuotaDollorEmpty = true;
        isError = true;
        this.$toast.info({ title: "[日額金額]欄位不得為空" });
      }
      return isError;
    },
    insertSchemeData() {
      if (this.validateSchemeForm()) {
        return;
      }
      let reqData = {
        schemeid: this.formData.productId,
        name:
          this.formData.schemeQuotaType == "0"
            ? this.formData.schemeName
            : this.formData.schemeName + "_1", //若不顯示，填寫內容後多串固定字元“_1”
        quantity: this.formData.schemeQuotaDollor,
      };
      insertSchemeData(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.formData.productId = result.data.schemeid;
            this.querySchemeData();
            this.initSchemeForm();
            this.$toast.info({ title: "新增成功" });
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    updateSchemeData(data) {
      if (this.validateSchemeEditForm()) {
        return;
      }
      let reqData = {
        schemeid: this.formData.productId,
        quantity: this.schemeEditQuotaDollor,
        position: data.position,
      };
      updateSchemeData(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.isSchemeEdit = false;
            this.schemeEditQuotaDollor = "";
            this.querySchemeData();
            this.$toast.info({ title: "更新成功" });
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    deleteSchemeData(data) {
      if (confirm("確認是否刪除！？")) {
        let reqData = {
          schemeid: this.formData.productId,
          position: data.position,
        };
        deleteSchemeData(this.$store.state.userInfo.id, reqData).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.isSchemeEdit = false;
              this.schemeEditQuotaDollor = "";
              this.querySchemeData();
              this.$toast.info({ title: "更新成功" });
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      }
    },
    querySchemeData() {
      if (!this.formData.productId) {
        return;
      }
      this.isSchemeTableLoading = true;
      querySchemeData(
        this.$store.state.userInfo.id,
        this.formData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.schemeData = result.data.map((v) => ({ ...v, editMode: false }));
        } else {
          this.schemeData = [];
        }
        this.isSchemeTableLoading = false;
      });
    },
    checkSchemeQuotaDollor() {
      if (this.formData.schemeQuotaDollor.length > 8) {
        this.formData.schemeQuotaDollor = this.formData.schemeQuotaDollor.slice(
          0,
          8
        );
      }
    },
    checkSchemeEditQuotaDollor() {
      if (this.schemeEditQuotaDollor.length > 8) {
        this.schemeEditQuotaDollor = this.schemeEditQuotaDollor.slice(0, 8);
      }
    },
    checkEndYear() {
      if (this.formData.endYear.length > 3) {
        this.formData.endYear = this.formData.endYear.slice(0, 3);
      }
    },
    checkSelfRenewal() {
      if (this.formData.selfRenewal.length > 3) {
        this.formData.selfRenewal = this.formData.selfRenewal.slice(0, 3);
      }
    },
    checkSpouseRenewal() {
      if (this.formData.spouseRenewal.length > 3) {
        this.formData.spouseRenewal = this.formData.spouseRenewal.slice(0, 3);
      }
    },
    checkChildRenewal() {
      if (this.formData.childRenewal.length > 3) {
        this.formData.childRenewal = this.formData.childRenewal.slice(0, 3);
      }
    },
    checkUnitPrice() {
      if (this.formData.unitPrice.length > 8) {
        this.formData.unitPrice = this.formData.unitPrice.slice(0, 8);
      }
    },
    doSchemeEdit(data) {
      data.editMode = true;
      this.isSchemeEdit = true;
      this.schemeEditQuotaDollor = data.quantity;
    },
    cancelSchemeEdit(data) {
      data.editMode = false;
      this.isSchemeEdit = false;
      this.schemeEditQuotaDollor = "";
      this.isSchemeEditQuotaDollorEmpty = false;
    },
    initSchemeForm() {
      this.formData.schemeName = "";
      this.formData.schemeQuotaType = "0";
      this.formData.schemeQuotaDollor = "";
    },
  },
};
